<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBrowserRefresh: !this.$route.name,
    }
  },
  created() {
    if (this.isBrowserRefresh && this.$store.state.user.addFormNum !== 1) {
      this.$store.dispatch('user/resetRefreshNum')
      if(this.$store.state.user.refreshNum % 4 === 0) {
        this.$store.dispatch('user/resetUserInfo');
	this.$store.commit('user/SET_API_COUNT', 1);
      } else {
      	let urls = window.location.href.split("?");
	if(urls.length > 1) {
		if(urls[0].indexOf("pay") !== -1 && urls[1].length > 20) {
			this.$store.dispatch('user/resetUserInfo');
			this.$store.commit('user/SET_REFRESH_NUM', 1);
			this.$store.commit('user/SET_API_COUNT', 1);
		}
	}
      }
    }
  },
}
</script>
